import { observer } from "mobx-react-lite";
import { useRouteMatch } from "react-router";
import React, { useContext, useEffect, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { ListDataSource, LoggerFactory, routerContext } from "../../index";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
// @ts-ignore
import SanitizedHTML from "react-sanitized-html";

export interface PresentationalForeignKeyProps extends FieldRenderProps<any> {
  dataSource: ListDataSource<{}, {}>;
  valueField: string;
  labelField: string | ((option: {}) => string);
  searchField?: string;
  routeDestination: string;
  routeDestinationField?: string;
}

const useStyles = makeStyles({
  link: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});

const log = LoggerFactory.create("ForeignKeyRenderer");

export const ForeignKeyRenderer = observer(
  (props: PresentationalForeignKeyProps) => {
    const {
      dataSource,
      input,
      labelField,
      routeDestination,
      routeDestinationField,
      valueField,
      asHtml
    } = props;
    const classes = useStyles();
    const [label, setLabel] = useState("");
    const [routeId, setRouteId] = useState("");
    const { homeRoute } = useContext(routerContext);

    const match = useRouteMatch({
      path: `/${homeRoute}/`
    });
    log.debug("match", match);

    useEffect((): void => {
      const itemToRender = dataSource.list.find(
        // equality operator used intentionally
        (item: any) => item[valueField] == input.value
      );

      if (itemToRender) {
        if (labelField instanceof Function) {
          setLabel(labelField(itemToRender));
        } else {
          setLabel(itemToRender[labelField]);
        }
        setRouteId(
          routeDestinationField
            ? itemToRender[routeDestinationField]
            : itemToRender[valueField]
        );
      } else {
        setLabel("");
        if (dataSource.list.length > 0) {
          log.warn("Did not find matching entry", input.value);
        }
      }
    }, [dataSource.list, input.value, valueField, labelField, asHtml, label]);

    return (
      <>
        {match?.url && routeDestination ? (
          <Link
            className={classes.link}
            to={`${match.url}/${routeDestination}/${routeId}`}
          >
            <SanitizedHTML html={label} />
          </Link>
        ) : (
          <span className={classes.link}>
            <SanitizedHTML html={label} />
          </span>
        )}
      </>
    );
  }
);
